import React, { useEffect, useState } from 'react';
import styles from './TextSelector.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Tooltip from 'component/Custom/tooltip/Tooltip';

const TextSelector = ({
  title,
  options = [],
  values,
  setFieldValue,
  fieldName,
  tooltipContent,
}) => {
  const opts =
    options.length > 0
      ? options
      : [{ label: 'Text' }, { label: 'Icon + Text' }];

  const getLabel = (opt) =>
    typeof opt === 'string' ? opt : (opt && opt.label) || '';
  const getAlign = (opt) =>
    (typeof opt === 'object' && opt.position) || 'center';

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!values || !fieldName) return;
    const currentValue = values[fieldName];
    const idx = opts.findIndex(
      (opt) =>
        getLabel(opt).toLowerCase() === (currentValue || '').toLowerCase()
    );
    if (idx >= 0) {
      setSelectedIndex(idx);
    }
  }, [values, fieldName, opts]);

  const handleSelect = (i) => {
    setSelectedIndex(i);
    const val = getLabel(opts[i]);
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, val);
    }
  };

  return (
    <div className={styles['text-selector']}>
      <div className={styles['text-selector-header']}>
        <p className={styles['input-title']}>{title}</p>
        <Tooltip content={tooltipContent} className={styles.tooltip}>
          <SvgWithBranding
            type='info'
            color='#682ECB'
            className={styles['info-icon']}
          />
        </Tooltip>
      </div>

      <div className={styles['text-selector-options']}>
        {opts.map((opt, i) => (
          <div
            key={i}
            className={`${styles['text-option']} ${
              i === selectedIndex ? styles['is-selected'] : ''
            }`}
          >
            <div
              className={`${styles['text-option-card']} ${
                i === selectedIndex ? styles['selected'] : ''
              }`}
              onClick={() => handleSelect(i)}
              role='button'
              tabIndex={0}
              onKeyDown={(e) =>
                (e.key === 'Enter' || e.key === ' ') && handleSelect(i)
              }
              style={{
                border:
                  i === selectedIndex
                    ? '1.5px solid #128DEA'
                    : '1.5px solid transparent',
              }}
            >
              <p style={{ textAlign: getAlign(opt) }}>{getLabel(opt)}</p>
            </div>
            <div
              className={`${styles['strip']} ${
                i === selectedIndex ? styles['stripActive'] : ''
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextSelector;
